import { styled } from '@mui/material';

export const LoadingDots = (): JSX.Element => {
  return (
    <LoadingDotsWrapper>
      <div></div>
      <div></div>
      <div></div>
    </LoadingDotsWrapper>
  );
};

const LoadingDotsWrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin-left: -18px;
  margin-top: -26px;
  position: absolute;

  div {
    width: 8px;
    height: 8px;
    margin: 0 2px;
    border-radius: 50%;
    background-color: #000;
    opacity: 0.3;
    animation: bouncing-loader 0.8s infinite alternate;
    animation-timing-function: cubic-bezier(1, 0, 0.8, 0);
  }

  @keyframes bouncing-loader {
    to {
      transform: translateY(-10px);
      opacity: 1;
    }
  }

  & > div:nth-of-type(2) {
    animation-delay: 0.2s;
  }

  & > div:nth-of-type(3) {
    animation-delay: 0.4s;
  }
`;
